// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"385de427","135":"d4a5c0cd","440":"fb68a466","524":"f1de9193","757":"2784b8c5","777":"978fe4b0","779":"e750f2e1","875":"b37fad64"}[chunkId] + ".chunk.js";
};